module.exports = __webpack_public_path__ + "img/qiyewenhua.0d689805.png";